import { useEffect, useState } from 'react';

const QUERY = '(pointer: coarse)';

const getMatch = () =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
        ? window.matchMedia(QUERY).matches
        : false;

// Detects touch-first / coarse-pointer devices (and Chrome DevTools device emulation).
// Re-renders live when the pointer type changes (DevTools toggle, device rotation).
export default function useCoarsePointer() {
    const [isCoarse, setIsCoarse] = useState(getMatch);

    useEffect(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
        const mql = window.matchMedia(QUERY);
        const handler = (e) => setIsCoarse(e.matches);
        setIsCoarse(mql.matches); // resync on mount (e.g. DevTools toggled before mount)
        if (mql.addEventListener) mql.addEventListener('change', handler);
        else mql.addListener(handler); // Safari < 14
        return () => {
            if (mql.removeEventListener) mql.removeEventListener('change', handler);
            else mql.removeListener(handler);
        };
    }, []);

    return isCoarse;
}
